/**
 * The shift concept, switched off — see ehr-server src/utils/users/shift.ts for the why.
 *
 * While this is false the login screen asks for no status or end time, and everything that
 * used to be reserved for an in-shift user (assigning yourself as appointment owner, the
 * owner name in the patient header) is simply available. The one thing that does not come
 * back as "always on" is End shift: there is no shift to end, so those menu entries and the
 * end-of-shift prompt stay hidden rather than becoming permanent.
 *
 * Set shiftEnabled: true in config.js — and SHIFT_ENABLED=true on ehr-server, both are
 * needed — to restore the original behaviour.
 */
export const shiftEnabled: boolean = !!(window as any).config?.shiftEnabled
